@if (isIconButton()) {
  <button class="icon-button" (click)="open($event)">
    <ng-icon name="tablerLock" size="16" />
  </button>
} @else {
  <button appPrimaryBtn type="button" (click)="open($event)">
    <ng-icon name="tablerLock" size="16" />
    Request Access
  </button>
}

<dialog #dialog class="ra__dialog" (click)="onDialogClick($event)">
  <div class="ra__modal">
    <!-- Close -->
    <button class="ra__close" type="button" (click)="close()" aria-label="Close">
      <ng-icon name="tablerX" size="18" />
    </button>

    <!-- Header -->
    <h2 class="ra__title">Request Access</h2>
    <p class="ra__subtitle">Provide required details to access the asset "{{ assetName() }}".</p>

    <!-- Requesting as -->
    <p class="ra__section-label">Requesting as</p>
    <div class="ra__user-card">
      <div class="ra__avatar">
        @if (userPhotoUrl()) {
          <img [src]="userPhotoUrl()" alt="" />
        } @else {
          {{ userInitials() }}
        }
      </div>
      <div class="ra__user-info">
        <span class="ra__user-name">{{ user()?.displayName }}</span>
        <span class="ra__user-meta">{{ userMeta() }}</span>
      </div>
    </div>

    <!-- Reason -->
    <div class="ra__field">
      <label class="ra__label">
        Reason for Access Request <span class="ra__required">*</span>
      </label>
      <div class="ra__reason-btns">
        @for (r of reasons; track r.id) {
          <button
            class="ra__reason-btn"
            [class.ra__reason-btn--active]="selectedReason() === r.id"
            type="button"
            (click)="selectedReason.set(r.id)"
          >
            {{ r.label }}
          </button>
        }
      </div>
    </div>

    <!-- Justification -->
    <div class="ra__field">
      <textarea
        #justifyField
        class="ra__textarea"
        rows="4"
        placeholder="Enter a justification for how you plan to use this asset"
        [value]="justification()"
        (input)="justification.set(justifyField.value)"
      ></textarea>
    </div>

    <!-- Project Name -->
    <div class="ra__field">
      <label class="ra__label" for="ra-project">Project Name</label>
      <input
        #projectField
        id="ra-project"
        class="ra__input"
        type="text"
        placeholder="Enter your project name (if applicable)"
        [value]="projectName()"
        (input)="projectName.set(projectField.value)"
      />
    </div>

    <!-- Legal -->
    <p class="ra__legal">
      By requesting access, you consent to sharing your ADB details with the Asset Owner and agree
      to ADB's
      <a class="ra__link" href="https://www.adb.org/terms-use" target="_blank" rel="noopener"
        >Terms of Use</a
      >
      and
      <a
        class="ra__link"
        href="https://www.adb.org/who-we-are/access-information"
        target="_blank"
        rel="noopener"
        >Access to Information</a
      >
      policies.
    </p>

    <!-- Actions -->
    <div class="ra__actions">
      <button class="ra__cancel" type="button" (click)="close()">Cancel</button>
      <button
        class="ra__submit"
        type="button"
        [disabled]="!canSubmit() || isPending()"
        (click)="submit()"
      >
        @if (isPending()) {
          <loader color="white" size="16px" />
        } @else {
          Submit Request
        }
      </button>
    </div>
  </div>
</dialog>
